import React, { Component } from "react";
import { Redirect } from "react-router-dom";

import API from "../../apiService.js";
import ALERT, { confirmedAlert } from "../component/Alert";
import Modal from "../form/ModalRujukan";
import "react-datepicker/dist/react-datepicker.css";
import PrintRunjukan from "../form/PrintRujukan";
import Autocomplete from "react-autocomplete";
import moment from "moment";
import ModalInternal from "../form/ModalRujukanInternal";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import PrintModal from "../form/PrintModal";
import BlobPrint from "view/component/BlobPrint.js";
import print from "print-js";
import Sisroute from "view/sisroute/Sisroute.js";
import { getBase64 } from "view/component/helper/helper.js";
import apiService from "../../apiService";

const SignupSchema = Yup.object().shape({
    icd: Yup.string().required("ICD HARUS DIISI"),
});

class PlanningPsikologi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visit_id: props.patient.id,
            advice: {
                id: props.patient.advice ? props.patient.advice.advice : "",
                visit_id: props.patient.id,
                advice: props.patient.advice ? props.patient.advice.advice : "",
                evaluation: props.patient.advice ? props.patient.advice.evaluation : "",
                intervensi_psikologis: props.patient.advice ? props.patient.advice.intervensi_psikologis : "",
            },
            examFinish: false,
            ref_continue: [],
            continue_id: props.patient.continue_id ? props.patient.continue_id : "1",
            modalShow: false,
            modalInternal: false,
            modalPrint: false,
            date: moment(new Date()).format("YYYY-MM-DD"),
            drugsData: [],
            dataTreatments: [],
            treatments: [
                {
                    visit_id: "",
                    visit_inpatient_detail_id: "",
                    treatment_id: "",
                    log: "0",
                    treatment: { name: "" },
                },
            ],
            ref_prognosis: [],
            anamneses: props.patient.anamneses[0] ? props.patient.anamneses[0] : "",
            modalSisroute: false,
            dataSisroute: false,
            imageSisroute: [],
            reVisit: {
                days: 0,
                date: moment().format('YYYY-MM-DD'),
                notified: false
            },
        };
        this.timeout = 0;
        this.PostData = this.PostData.bind(this);
        this.PutData = this.PutData.bind(this);
        this.handlePrognosisChange = this.handlePrognosisChange.bind(this);
        this.postRawatInap = this.postRawatInap.bind(this);
        this.changeRevisitDate = this.changeRevisitDate.bind(this);
        this.changeDateReVisit = this.changeDateReVisit.bind(this);
        this.changeWanotifed = this.changeWanotifed.bind(this);
        this.changeCatatanMix = this.changeCatatanMix.bind(this);
        this.changeCatatan = this.changeCatatan.bind(this);
        this.handlePsikologTypeChange = this.handlePsikologTypeChange.bind(this);

    }

    componentDidMount() {
        this.getContinue();
        this.getPrognosis();
        let drugsMix = [];
        let drugs = [];
        if (this.props.patient.prescribes.length > 0) {
            this.props.patient.prescribes.map((prescribes, y) => {
                if (prescribes.combination_name !== "") {
                    drugsMix.push(prescribes);
                } else {
                    drugs.push(prescribes);
                }
            });
            this.setState({
                drugs,
                drugsMix,
            });
        }
        if (this.props.patient.treatments[0]) {
            // console.log("yey");
            this.setState({
                treatments: this.props.patient.treatments,
            });
        }
        // console.log(drugs);
    }

    notify(param) {
        Toastify({
            text: param,
            backgroundColor: "linear(to right)",
            className: "info",
        }).showToast();
    }

    cetakRujukan = async (e) => {
        const res = await API.getblob(
            "/registration/print/rujukan?id=" + this.props.patient.id
        );
        if (res) {
            const file = new Blob([res], { type: "application/pdf" });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //print blob
            print(fileURL);
        }
    };

    retrieveDataAsynchronouslyDrugs = async (e) => {
        const res = await API.get("drug/stock/read?keyword=" + e);
        if (res.code === 200) {
            // let first = res.data.filter((dat) => dat.user_approval_id !== null && dat.stock_in.qty - dat.item.stock_out.qty > 0);
            this.setState({
                drugsData: res.data.filter(
                    (dat) =>
                        dat.user_approval_id !== null &&
                        dat.stock_in.qty - dat.stock_out.qty > 0
                ),
            });
        } else {
            console.error("Cannot load data from remote source");
        }
    };

    /**
     * Callback triggered when the autocomplete input changes.
     *
     * @param {Object} val Value returned by the getItemValue function.
     * @return {Nothing} No value is returned
     */
    onSelect(val) {
        this.setState({
            value: val,
        });
        const x = val.split("-", 2);
        console.log("Option from 'database' selected : ", x);
    }

    //tindakan
    handleInputNameChangeTreatments = (idx) => (evt) => {
        const val = evt.split("-", 2);
        // console.log(evt.target.value);
        const newTreatments = this.state.treatments.map((tr, sidx) => {
            if (idx !== sidx) return tr;
            return {
                visit_id: this.props.patient.id,
                visit_inpatient_detail_id: "1",
                treatment_id: val[0],
                log: "0",
                treatment: { name: val[1] },
            };
        });

        this.setState({ treatments: newTreatments });
        this.setState({ value: evt });
        setTimeout(
            function () {
                let parent = [];
                parent = { data: this.state.treatments, param: "treatments" };
                this.props.parentCallback(parent);
            }.bind(this),
            200
        );
    };

    postTreatments = async (e) => {
        const treatment = this.state.treatments;
        const res = await API.put("/registration/treatment/update", { treatment });
        // if (res.code === 200) {
        //   // ALERT("success", "Berhasil Menyimpan Data ");
        // } else {
        //   // ALERT("error", "gagal menyimpan data");
        // }
    };
    handleRemoveInputTreatments = (idx) => (evt) => {
        const treatments = [...this.state.treatments];
        treatments[idx].log = 1;
        if (treatments[idx].treatment_id !== "") {
            this.setState({ treatments });
        } else {
            this.setState({
                [evt.target.name]: this.state.treatments.filter(
                    (s, sidx) => idx !== sidx
                ),
            });
        }
    };
    retrieveDataAsynchronouslyTreatments = async (e) => {
        // console.log(e);
        let payment_type_id = this.props.patient.payment_type_id;
        let res = await API.get(
            "management/treatments_price/read?payment_type=" +
            payment_type_id +
            "&keyword=" +
            e
        );
        if (res.code === 200) {
            this.setState({
                dataTreatments: res.data,
            });
        } else {
            // console.error("Cannot load data from remote source");
            this.setState({
                dataTreatments: [],
            });
        }
    };
    onChangeTreatments = (idx) => (evt) => {
        const newTreatments = this.state.treatments.map((tr, sidx) => {
            if (idx !== sidx) return tr;
            return {
                visit_id: this.props.patient.id,
                visit_inpatient_detail_id: "1",
                treatment_id: "",
                log: "0",
                treatment: { name: evt.target.value },
            };
        });

        this.setState({ treatments: newTreatments });

        /**
         * Handle the remote request with the current text !
         */
        const par = evt.target.value;
        // if (evt.target.value.length > 2) {
        // setTimeout(event => {
        // this.retrieveDataAsynchronouslyTreatments(par);
        // }, 300);
        // console.log("The Input Text has changed to ", par);
        // }
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            //search function
            this.retrieveDataAsynchronouslyTreatments(par);
        }, 500);
    };

    getItemValueTreatments(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.treatment_id}-${item.treatment.name}`;
    }

    //tindakan end
    handleAddInput = (x) => (evt) => {
        this.setState({
            [evt.target.name]: x,
        });
    };
    getContinue = async (e) => {
        const res = await API.get("management/continues/read/1");
        if (res.code === 200) {
            this.setState({
                ref_continue: res.data,
            });
        } else {
            console.error("Cannot load data from remote source");
        }
    };

    getPrognosis = async (e) => {
        const res = await API.get("management/prognosis/read");
        if (res.code === 200) {
            this.setState({
                ref_prognosis: res.data,
            });
        } else {
            console.error("Cannot load data from remote source");
        }
    };

    handleTextChange = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        let advice = this.state.advice;
        let data = [];
        advice[name] = value;
        this.setState({ advice }, () =>
            this.props.parentCallback({ data: this.state.advice, param: "advice" })
        );
        // data = { data: [this.state.advice], param: "advice" };
        // console.log(this.state);
    };
    handlePrognosisChange = (e) => {
        let value = e.target.value;
        let anamneses = [];
        this.setState(
            (prevState) => ({
                anamneses: {
                    // object that we want to update
                    ...prevState.anamneses, // keep all other key-value pairs
                    prognosis_id: value, // update the value of specific key
                },
            }),
            () => {
                anamneses = { data: [this.state.anamneses], param: "anamneses" };
                // console.log(this.state);
                this.props.parentCallback(anamneses);
                this.PutDataAnamneses();
            }
        );
        // this.setState(
        //   {
        //     [e.target.name]: e.target.value,
        //   },
        //   () => {
        //     anamneses = { data: [this.state], param: "anamneses" };
        //     // console.log(this.state);
        //     this.props.parentCallback(anamneses);
        //   }
        // );
    };
    handlePsikologTypeChange = (e) => {
        let value = e.target.value;
        let anamneses = [];
        this.setState(
            (prevState) => ({
                anamneses: {
                    // object that we want to update
                    ...prevState.anamneses, // keep all other key-value pairs
                    psikologi_type_visit: value, // update the value of specific key
                },
            }),
            () => {
                anamneses = { data: [this.state.anamneses], param: "anamneses" };
                // console.log(this.state);
                this.props.parentCallback(anamneses);
                this.PutDataAnamneses();
            }
        );
        // this.setState(
        //   {
        //     [e.target.name]: e.target.value,
        //   },
        //   () => {
        //     anamneses = { data: [this.state], param: "anamneses" };
        //     // console.log(this.state);
        //     this.props.parentCallback(anamneses);
        //   }
        // );
    };

    PutDataAnamneses = async () => {
        var param = this.state.anamneses;
        const res = await API.put("management/anamneses/update", param);
    };
    handleSubmit = (e) => {
        if (this.props.patient.diagnoses[0]) {
            if (this.state.advice.id > 0) {
                this.PutData();
            } else {
                this.PostData();
            }
            this.PutVisit();
            // this.PostFhir();
            // this.PutNutrition();
            this.postTreatments();
            if (this.state.continue_id == 2) {
                this.postRawatInap();
            }
            this.PostFhir();

        } else {
            this.notify("ICD HARUS DIISI");
        }
    };

    PostFhir = async () => {
        for (let index = 0; index < this.props.patient.diagnoses.length; index++) {
            const diag = this.props.patient.diagnoses[index];
            let condition = await API.post(`fhir/satu_sehat/condition/single/${this.props.patient.id}`, { icd: diag.icd_code });
        }
        // let condition = await API.post(`fhir/satu_sehat/condition/${this.props.patient.id}`);
        let putEncounter = await API.put(`/fhir/satu_sehat/encounterAll/${this.props.patient.id}`);
    }
    PutVisit = async () => {
        let userData = JSON.parse(localStorage.getItem("userData"));
        let visit = {
            id: this.state.visit_id,
            continue_id: this.state.continue_id,
            served: 1,
            paramedic_id: userData.id,
            comeback_date: this.state.reVisit.date,
            reminded: this.state.reVisit.notified
        };
        let res = await API.put(`registration/change/visit`, { visit });
        if (res.code === 200) {
            this.postPcare();
            if (this.state.dataSisroute) {
                this.postSisroute();
            }
        }
    };

    hadleRujukan = (e) => {
        if (this.props.patient.diagnoses[0]) {
            let name = e.target.name;
            let value = e.target.value;
            this.setState({
                [name]: value,
            });
            let rujukan = e.target.value;
            // console.log(rujukan);

            if (rujukan === "3") {
                this.setState({
                    modalShow: true,
                });
            } else if (rujukan === "6") {
                this.setState({
                    modalInternal: true,
                });
            }
        } else {
            this.notify("ICD HARUS DIISI");

        }
    };
    holdSimpan = () => {
        let pr = this.props;
        let th = this;
        confirmedAlert(
            "Info",
            "Apakah anda akan menghapus Melakukan Transaksi lain ? (seperti cetak surat sehat / sakit, dll) ",
            function (confirmed) {
                if (confirmed) {
                    pr.getData();
                } else {
                    // NO
                    setTimeout(() => th.setState({ examFinish: true }), 1000);
                }
            }
        );
    };
    postPcare = async (e) => {
        const res = await API.post("pcare/kunjungan/" + this.props.patient.id);
        // BlobPrint('registration/print/rujukan?id=' + this.props.patient.id)
        if (res) {
            // console.log(res);
            if (res?.metaData?.code === 200 || res?.metaData?.code === 201) {
                if (this.state.continue_id == 3) {
                    // BlobPrint("registration/print/rujukan?id=" + this.props.patient.id);
                    this.cetakRujukan();
                } else {
                    // setTimeout(() => this.setState({ examFinish: true }), 1000);
                    ALERT("success", "Berhasil Menyimpan Data ");
                    setTimeout(() => this.holdSimpan(), 1000);
                }
                let Obat = await API.post(`pcare/obat/` + this.props.patient.id);
                let Tindakan = await API.post(
                    `pcare/tindakan/` + this.props.patient.id
                );
                let mcu = await API.post(`pcare/mcu/` + this.props.patient.id);
            } else {
                ALERT("error", "data tersimpan, gagal mengirim ke pcare");
                setTimeout(() => this.holdSimpan(), 1000);
            }
        }
    };

    PostData = async () => {
        var param = this.state.advice;
        let res = await API.post(`registration/advice/create`, param);
    };

    PutData = async () => {
        var param = this.state.advice;
        let res = await API.put(`registration/advice/update`, param);
        if (res.code === 200) {
            setTimeout(() => this.setState({ examFinish: true }), 2000);
            ALERT("success", "Berhasil Menyimpan Data ");
        } else {
            ALERT("error", "gagal menyimpan data");
            // console.log(this.state);
            // if (this.state.continue_id === 3) {
            //   console.log(this.state);

            //   this.setState({ modalPrint: true });
        }
    };

    handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({
            [name]: value,
        });
        // console.log(this.state);
    };
    onReload = () => {
        this.props.history.push("/pelayanan");
    };
    //sisroute
    postSisroute = async () => {
        let res = await API.post("/sisrute/referral/post", this.state.dataSisroute);
        if (res?.success) {
            if (this.state.imageSisroute.length > 0) {
                let filex = await getBase64(this.state.imageSisroute[0]);
                let dat = {
                    nomor: res.data?.RUJUKAN?.NOMOR,
                    jenis: 1,
                    file: filex,
                    action: "save",
                };
                console.log(filex);
                let postImage = await API.post("/sisrute/referral/image", dat);
            }
        }
    };
    changeSisroute = (val) => {
        this.setState({ dataSisroute: val });
    };

    postRawatInap = async () => {
        let param = {
            nik: this.props.patient.patients.nik,
            name: this.props.patient.patients.name,
            last_name: this.props.patient.patients.last_name,
            sex: this.props.patient.patients.sex,
            parent_name: this.props.patient.patients.parent_name,
            birth_place: this.props.patient.patients.birth_place,
            birth_date: this.props.patient.patients.birth_date,
            address: this.props.patient.patients.address,
            village_id: this.props.patient.patients.village_id,
            education_id: this.props.patient.patients.education_id,
            job_id: this.props.patient.patients.job_id,
            religion_id: this.props.patient.patients.religion_id,
            marital_status_id: this.props.patient.patients.marital_status_id,
            contact: this.props.patient.patients.contact,
            photo: this.props.patient.patients.photo,
            flag: this.props.patient.patients.flag,
            rekam_medis_flags: this.props.patient.patients.rekam_medis_flags,
            parent_id: this.props.patient.parent_id,
            patient_id: this.props.patient.patient_id,
            family_folder: this.props.patient.family_folder,
            family_relationship_id: this.props.patient.family_relationship_id,
            paramedic_id: null,
            // user_id_poli: this.props.patient.user_id_poli,
            payment_type_id: this.props.patient.payment_type_id,
            clinic_id: 10,
            insurance_no: this.props.patient.insurance_no,
            resume: this.props.patient.resume,
            previous_clinic_id: this.props.patient.clinic_id,
            continue_id: 0,
            continue_to: this.props.patient.continue_to,
            continue_internal: null,
            served: false,
            pcare_patient_code_provider:
                this.props.patient.pcare_patient_code_provider,
            admission_type_id: this.props.patient.admission_type_id,
            drug_taken: this.props.patient.drug_taken,
            specialis: this.props.patient.specialis,
            visit_type: this.props.patient.visit_type,
            served_card: this.props.patient.served_card,
            clinic_group: this.props.patient.clinic_group,
            nurse_id: null,
            kd_sadar: this.props.patient.kd_sadar,
            kd_tacc: this.props.patient.kd_tacc,
            pcare_visit_number: null,
            pcare_queue_number: null,
            pcare_treatment_code: 20,
            pcare_sick: 1,
            queue: null,
            statuscall: "0",
            statustracer: "0",
            flg_outdoor: null,
            outdoor_visit_id: null,
            ambulance: "0",
            flg_resume: null,
            drug_queue: null,
            bloodId: this.props.patient.examinations[0].blood_type_id,
        };
        let res = await API.post(`registration/visit`, param);
        if (res.code === 200 || res.code === 201) {
            let par = {
                visit_id: res.data?.visit?.id,
                entry_icd_code: "",
                inpatient_continue_id: null,
                entry_date: moment(new Date()).format("YYYY-MM-DD"),
            };
            let ranap = await API.post("/registration/inpatient/create", par);
        }
    };

    changeRevisitDate = (val) => {
        this.setState({
            reVisit: {
                days: val,
                date: moment().add(val, 'days').format('YYYY-MM-DD')
            }
        });
    }
    changeWanotifed = (val) => {
        console.log(val);
        this.setState(
            (prevState) => ({
                reVisit: {
                    // object that we want to update
                    ...prevState.reVisit, // keep all other key-value pairs
                    notified: val, // update the value of specific key
                },
            })
        );
    }

    changeDateReVisit = (e) => {
        const d = moment();
        const s = moment(e, 'YYYY-MM-DD');
        const df = s.diff(d, 'days');

        this.setState({
            reVisit: {
                days: df,
                date: e
            }
        })
        console.log(df)
    }

    changeCatatan = (idx) => (evt) => {
        const val = evt.target.value;

        const drugs = [...this.state.drugs];
        drugs[idx].note = val;
        this.setState({ drugs });
        //  console.log(dr);
    };

    changeCatatanMix = (idx) => (evt) => {
        const val = evt.target.value;

        const drugsMix = [...this.state.drugsMix];
        drugsMix[idx].note = val;
        this.setState({ drugsMix });
        //  console.log(dr);
    };

    render() {
        if (this.state.examFinish) {
            return <Redirect to="/pelayanan" />;
        }
        var refContinue = this.state.ref_continue.map((con, idx) => {
            return (
                <option key={idx} value={con.id}>
                    {con.name}
                </option>
            );
        });
        let modalShow = this.state.modalShow;
        let modalInternal = this.state.modalInternal;
        let modalPrint = this.state.modalPrint;
        let renderRujukan =
            this.state.continue_id === 3 ? (
                <PrintRunjukan
                    patient={this.props.patient}
                    onHide={() => this.setState({ modalShow: false })}
                    ModalShow={() => this.setState({ modalShow: true })}
                    cetak={(e) => this.cetakRujukan()}
                />
            ) : (
                ""
            );
        let DeletedTreatment = [];
        this.state.treatments.map((treatment, idx) => {
            if (treatment.log > 0) {
                DeletedTreatment[idx] = treatment;
            }
        });
        const deletedTreatmentInformation = DeletedTreatment.map((data, key) => {
            return (
                <a key={key} className="dropdown-item">
                    {data.treatment.name}
                </a>
            );
        });
        return (
            <>
                <Formik
                    enableReinitialize
                    initialValues={{
                        icd: this.props.patient.diagnoses[0]
                            ? this.props.patient.diagnoses[0].icd_code
                            : "",
                    }}
                    validationSchema={SignupSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        this.handleSubmit();
                    }}
                >
                    {({ values, errors, touched, isSubmitting }) => (
                        <Form>
                            {errors.icd && touched.icd ? this.notify(errors.icd) : null}
                            <div className="form-group row">
                                <div className="col-md-5">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label
                                                htmlFor="example-text-input"
                                                className="col-form-label col-form-label-sm"
                                            >
                                                Tindakan
                                            </label>
                                        </div>
                                        {DeletedTreatment.length > 0 ? (
                                            <div>
                                                <div className="col-auto">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-danger mr-0"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        dihapus
                                                    </button>
                                                    <div className="dropdown-menu dropdown-menu-left">
                                                        {deletedTreatmentInformation}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    {this.state.treatments.map((tr, idx) => {
                                        if (tr.log < 1) {
                                            return (
                                                <div key={idx} className="form-group row">
                                                    <Autocomplete
                                                        inputProps={{
                                                            className: "form-control form-control-sm",
                                                            placeholder: "ketikkan minimal 3 huruf tindakan",
                                                        }}
                                                        items={this.state.dataTreatments}
                                                        getItemValue={this.getItemValueTreatments}
                                                        renderItem={(item, highlighted) => (
                                                            <div
                                                                key={item.id}
                                                                style={{
                                                                    backgroundColor: highlighted
                                                                        ? "#eee"
                                                                        : "transparent",
                                                                }}
                                                            >
                                                                {item.id} - {item.treatment.name} - (
                                                                {item.price})
                                                            </div>
                                                        )}
                                                        value={this.state.treatments[idx].treatment.name}
                                                        onChange={this.onChangeTreatments(idx)}
                                                        onSelect={this.handleInputNameChangeTreatments(idx)}
                                                        menuStyle={{
                                                            borderRadius: "3px",
                                                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                                            background: "rgba(255, 255, 255, 0.9)",
                                                            padding: "2px 0",
                                                            fontSize: "90%",
                                                            // position: "absolute",
                                                            overflow: "auto",
                                                            zIndex: "100",
                                                            maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
                                                        }}
                                                        wrapperStyle={{
                                                            maxWidth: "81.66667%",
                                                            flex: "0 0 81.66667%",
                                                            overflow: "auto",
                                                            maxHeight: '300px'
                                                        }}
                                                    />

                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        style={{ maxWidth: "10%", maxHeight: "32px" }}
                                                        name="treatments"
                                                        onClick={this.handleRemoveInputTreatments(idx)}
                                                        type="button"
                                                    >
                                                        -
                                                    </button>
                                                </div>
                                            );
                                        }
                                    })}
                                    <button
                                        type="button"
                                        name="treatments"
                                        style={{ marginLeft: "2%" }}
                                        onClick={this.handleAddInput(
                                            this.state.treatments.concat([
                                                {
                                                    visit_id: "",
                                                    visit_inpatient_detail_id: "",
                                                    treatment_id: "",
                                                    log: "0",
                                                    treatment: { name: "" },
                                                },
                                            ])
                                        )}
                                        className="btn btn-sm btn-primary"
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-5 col-form-label col-form-label-sm"
                                >
                                    Intervensi Psikolog
                                </label>
                                <div className="col-md-7">
                                    <div className="row">
                                        <textarea
                                            className="form-control form-control-sm"
                                            placeholder="saran untuk pasien"
                                            id="example-text-input"
                                            name="intervensi_psikologis"
                                            onChange={this.handleTextChange}
                                            value={this.state.advice.intervensi_psikologis}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-5 col-form-label col-form-label-sm"
                                >
                                    Advice
                                </label>
                                <div className="col-md-7">
                                    <div className="row">
                                        <textarea
                                            className="form-control form-control-sm"
                                            placeholder="saran untuk pasien"
                                            id="example-text-input"
                                            name="advice"
                                            onChange={this.handleTextChange}
                                            value={this.state.advice.advice}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-5 col-form-label col-form-label-sm"
                                >
                                    Evaluasi
                                </label>
                                <div className="col-md-7">
                                    <div className="row">
                                        <textarea
                                            className="form-control form-control-sm"
                                            placeholder="evalusai pasien"
                                            id="example-text-input"
                                            name="evaluation"
                                            onChange={this.handleTextChange}
                                            value={this.state.advice.evaluation}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-5 col-form-label col-form-label-sm"
                                >
                                    Prognosis
                                </label>
                                <div className="col-md-7">
                                    <div className="row">
                                        <select
                                            className="form-control form-control-sm"
                                            id="prognosis_id"
                                            name="prognosis_id"
                                            value={this.state.anamneses.prognosis_id}
                                            onChange={this.handlePrognosisChange}
                                        >
                                            {this.state.ref_prognosis.map((d, k) => (
                                                <option value={d.id} key={k}>
                                                    {d.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-5 col-form-label col-form-label-sm"
                                >
                                    Tindak Lanjut
                                </label>
                                <div className="col-md-7">
                                    <div className="row">
                                        <select
                                            className="form-control form-control-sm"
                                            id="example-text-input"
                                            name="continue_id"
                                            value={this.state.continue_id}
                                            onChange={this.hadleRujukan}
                                        >
                                            {refContinue}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-5 col-form-label col-form-label-sm"
                                >
                                    Jenis Kunjungan
                                </label>
                                <div className="col-md-7">
                                    <div className="row">
                                        <select
                                            className="form-control form-control-sm"
                                            id="psikologi_type_visit"
                                            name="psikologi_type_visit"
                                            value={this.state.anamneses.psikologi_type_visit}
                                            onChange={this.handlePsikologTypeChange}
                                        >
                                            <option>pilih</option>
                                            <option value='individu'>individu</option>
                                            <option value='ibu hamil'>ibu hamil</option>
                                            <option value='keluarga'>keluarga</option>
                                            <option value='kelompok'>kelompok</option>

                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-5 col-form-label col-form-label-sm"
                                >
                                    Tanggal Rencana Kembali
                                </label>
                                <div className="col-md-7">
                                    <div className="row">
                                        <input
                                            className="col-md-2 form-control form-control-sm"
                                            type="text"
                                            placeholder="hari"
                                            value={this.state.reVisit.days}
                                            onChange={(e) => this.changeRevisitDate(e.target.value)}
                                        />
                                        <input
                                            className="form-control form-control-sm col-md-7 ml-2"
                                            type="date"
                                            value={this.state.reVisit.date}
                                            onChange={
                                                (e) => this.changeDateReVisit(e.target.value)
                                            }

                                        />
                                        <label className="custom-toggle custom-toggle-success ml-2">
                                            <input
                                                type="checkbox"
                                                checked={
                                                    this.state.reVisit.notified
                                                }
                                                onChange={(e) => this.changeWanotifed(e.target.checked)}
                                            />
                                            <span
                                                className="custom-toggle-slider rounded-circle"
                                                data-label-off="no"
                                                data-label-on="wa"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {renderRujukan}
                            {this.state.modalSisroute ? (
                                <Sisroute
                                    patient={this.props.patient}
                                    onHide={() => this.setState({ modalSisroute: false })}
                                    show={this.state.modalSisroute}
                                    change={(e) => this.changeSisroute(e)}
                                    image={{
                                        change: (e) => this.setState({ imageSisroute: e }),
                                        data: this.state.imageSisroute,
                                    }}
                                />
                            ) : (
                                ""
                            )}
                            <button
                                className="btn btn-primary"
                                disabled={isSubmitting}
                                type="submit"
                            >
                                Simpan
                            </button>
                            <button
                                className="btn btn-danger"
                                type="button"
                                onClick={this.onReload}
                            >
                                Tutup
                            </button>
                            {modalShow ? (
                                <Modal
                                    show={modalShow}
                                    onHide={() => this.setState({ modalShow: false })}
                                    sisroute={() => this.setState({ modalSisroute: true })}
                                    patient={this.props.patient}
                                />
                            ) : (
                                ""
                            )}

                            {modalInternal ? (
                                <ModalInternal
                                    show={modalInternal}
                                    onHide={() => this.setState({ modalInternal: false })}
                                    patient={this.props.patient}
                                    handleSubmit={this.handleSubmit}
                                />
                            ) : (
                                ""
                            )}
                        </Form>
                    )}
                </Formik>
            </>
        );
    }
}

export default PlanningPsikologi;
